import { render, staticRenderFns } from "./StudentCourseInfo.vue?vue&type=template&id=5310c3e4&"
import script from "./StudentCourseInfo.vue?vue&type=script&lang=js&"
export * from "./StudentCourseInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports